import { useEffect, useState } from 'react';
import { MsalInstance } from '../MsalInstance';

export const useInitialize = (instance: MsalInstance) => {
  const [isInitializing, setIsInitializing] = useState(true);

  const handleInitialize = async () => {
    instance.initialize().finally(() => {
      setIsInitializing(false);
    });
  };

  useEffect(() => {
    handleInitialize();
  }, []);

  return { isInitializing };
};
